import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=283d839b&scoped=true&"
import script from "./NotificationCard.vue?vue&type=script&lang=js&"
export * from "./NotificationCard.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCard.vue?vue&type=style&index=0&id=283d839b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "283d839b",
  null
  
)

export default component.exports